import { TableCell, TableCellProps } from "@mui/material";
import { MedalBronze, MedalGold, MedalSilver } from "assets/images";
import { FC } from "react";
import "./LeaderBoardPodiumTableCell.scss";

interface Props {
  position: number;
}

export const PodiumTableCell: FC<Props & TableCellProps> = (props) => {
  const getIconForPosition = () => {
    return (
      <>
        {props.position === 1 && (
          <img
            src={MedalGold}
            alt="Gold medal icon"
            className="PositionImage"
          />
        )}
        {props.position === 2 && (
          <img
            src={MedalSilver}
            alt="Silver medal icon"
            className="PositionImage"
          />
        )}
        {props.position === 3 && (
          <img
            src={MedalBronze}
            alt="Bronze medal icon"
            className="PositionImage"
          />
        )}
      </>
    );
  };

  return (
    <TableCell {...props}>
      <div className="PositionContent">
        {getIconForPosition()}
        <div className={`PositionLabel ${[1, 2 ,3].includes(props.position) ? "PositionLabelPodium" : ""}`}>{props.position}</div>
      </div>
    </TableCell>
  );
};
